import $ from 'jquery';
import EventColumn from '../../../../events/EventColumn/EventColumn';

export default {

  name: 'event-timeline-block',

  props: {
    block: {}
  },

  components: {
    'event-column': EventColumn
  },

  inject: [
    'eventsData',
    'promises'
  ],

  watch: {
    filters: {
      handler: function (newValue) {
        this.filterEvents();
      },
      deep: true
    }
  },

  data () {
    return {
      isLoading: true,
      filteredEvents: [],
      monthSelected: null,
      daySelected: null,
      dragStartDays: 0,
      dragStartMonths: 0,
      dragDaysArea: null,
      dragMonthsArea: null,
      dragMaxDays: 0,
      dragMaxMonths: 0,
      dragAreaWidth: 0,
      previousMonthsToDisplay: 2,
      followingMonthsToDisplay: 18,
      monthNames: {
        'de': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        'en': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      }
    };
  },

  computed: {
    currentDate: function () {
      return new Date();
    },

    translationLocale: function () {
      return Translator.locale;
    },

    displayFromDate: function () {
      let dateFrom = new Date(this.currentDate);
      dateFrom = new Date(dateFrom.setMonth(dateFrom.getMonth() - this.previousMonthsToDisplay));
      dateFrom = dateFrom.setDate(1);
      return new Date(dateFrom);
    },

    displayToDate: function () {
      let dateTo = new Date(this.currentDate);
      dateTo = new Date(dateTo.setMonth(dateTo.getMonth() + this.followingMonthsToDisplay + 1));
      dateTo = dateTo.setDate(0);
      return new Date(dateTo);
    },

    monthsArea: function () {
      return $('.timeline-months');
    },

    daysArea: function () {
      return $('.timeline-days');
    }
  },

  // function definitions
  methods: {
    createCalendar: function () {
      let dayToAppend = new Date(this.displayFromDate);
      let monthShort = '';
      let yearShort = '';
      while (dayToAppend.getTime() < this.displayToDate.getTime()) {
        yearShort = ' ' + dayToAppend.getFullYear().toString().substring(2, 4);
        if (Translator.locale === 'de') {
          monthShort = (this.monthNames.de[dayToAppend.getMonth()]).substring(0, 3);
        } else {
          monthShort = (this.monthNames.en[dayToAppend.getMonth()]).substring(0, 3);
        }

        // add month on first day
        if (dayToAppend.getDate() === 1) {
          this.monthsArea.append("<div month='" + dayToAppend.getFullYear() + '-' + dayToAppend.getMonth() + "' class='timeline-month'>" + monthShort + yearShort + '</div>');
        }
        if (dayToAppend.getDate() === 1 || dayToAppend.getDate() % 8 === 0) {
          this.daysArea.append("<div date='" + dayToAppend.getFullYear() + '-' + dayToAppend.getMonth() + '-' + dayToAppend.getDate() + "' class='timeline-day'><div class='day-span'>" + dayToAppend.getDate() + ' ' + monthShort + '</div></div>');
        } else {
          this.daysArea.append("<div date='" + dayToAppend.getFullYear() + '-' + dayToAppend.getMonth() + '-' + dayToAppend.getDate() + "' class='timeline-day'></div>");
        }
        dayToAppend = dayToAppend.setDate(dayToAppend.getDate() + 1);
        dayToAppend = new Date(dayToAppend);
      }
      this.dragAreaWidth = -parseInt($('.timeline-area').css('width'));
      this.dragMaxMonths = -parseInt(this.monthsArea.css('width')) - this.dragAreaWidth;
      this.dragMaxDays = -parseInt(this.daysArea.css('width')) - this.dragAreaWidth;

      // scroll to current day / month
      let dateString = this.getDateString(this.currentDate);
      this.highlightMonth(dateString);
      this.scrollDayIntoView(dateString);
      this.appendEvents();
    },

    initDragMonths: function (e) {
      e = e || window.event;
      let clientX = e.clientX;
      if (!clientX) {
        clientX = e.touches[0].clientX;
      }
      this.dragStartMonths = clientX;
      document.body.addEventListener('mousemove', this.handleDragMonths, false);
      document.body.addEventListener('touchmove', this.handleDragMonths, false);
    },
    handleDragMonths: function (e) {
      e = e || window.event;
      let clientX = e.clientX;
      if (!clientX) {
        clientX = e.touches[0].clientX;
      }
      let dragTarget = this.dragStartMonths - clientX;
      let newPosition = (this.monthsArea.position().left - dragTarget);
      if (newPosition <= 0 && newPosition >= this.dragMaxMonths) {
        this.dragStartMonths = clientX;
        this.monthsArea.css('left', newPosition + 'px');
      }
    },

    initDragDays: function (e) {
      let clientX = e.clientX;
      if (!clientX) {
        clientX = e.touches[0].clientX;
      }
      this.dragStartDays = clientX;
      document.body.addEventListener('mousemove', this.handleDragDays, false);
      document.body.addEventListener('touchmove', this.handleDragDays, false);
    },
    handleDragDays: function (e) {
      e = e || window.event;
      let clientX = e.clientX;
      if (!clientX) {
        clientX = e.touches[0].clientX;
      }
      let dragTarget = this.dragStartDays - clientX;
      let newPosition = (this.daysArea.position().left - dragTarget);
      if (newPosition <= 0 && newPosition >= this.dragMaxDays) {
        this.dragStartDays = clientX;
        this.daysArea.css('left', newPosition + 'px');
      }
    },

    endDrag: function (e) {
      document.body.removeEventListener('mousemove', this.handleDragDays, false);
      document.body.removeEventListener('touchmove', this.handleDragDays, false);
      document.body.removeEventListener('mousemove', this.handleDragMonths, false);
      document.body.removeEventListener('touchmove', this.handleDragMonths, false);
    },

    highlightMonth: function (dateString) {
      $('.month-selected').removeClass('month-selected');
      let monthStringArray = dateString.split('-');
      let monthString = parseInt(monthStringArray[0]) + '-' + parseInt(monthStringArray[1]);
      let currentLeft = this.monthsArea.position().left;
      let currentRight = currentLeft + this.dragAreaWidth;
      let elements = $(".timeline-month[month='" + monthString + "']");
      let newPosition = -elements[0].offsetLeft + 10;
      if (currentLeft <= newPosition || currentRight >= newPosition) {
        if (newPosition > 0) {
          newPosition = 0;
        } else if (newPosition < this.dragMaxMonths) {
          newPosition = this.dragMaxMonths;
        }
        this.monthsArea.css('left', newPosition + 'px');
      }
      elements.addClass('month-selected');
    },

    scrollDayIntoView: function (dateString) {
      let elements = $(".timeline-day[date='" + dateString + "']");
      let newPosition = -elements[0].offsetLeft + 40;
      if (newPosition > 0) {
        newPosition = 0;
      }
      this.dragStartDays = newPosition;
      this.daysArea.css('left', newPosition + 'px');
    },

    highlightDay: function () {
      if (this.daySelected) {
        let elements = $(".timeline-event-column[date='" + this.daySelected + "']");
        elements.addClass('timeline-event-highlighted');
        this.daySelected = null;
      }
    },

    scrollMonths: function (direction) {
      let currentLeft = this.monthsArea.position().left;
      let newPosition = 0;
      let scrollWidth = (2 * this.dragAreaWidth / 3);
      if (direction === 'left') {
        newPosition = currentLeft - scrollWidth;
      } else {
        newPosition = currentLeft + scrollWidth;
      }
      if (newPosition > 0) {
        newPosition = 0;
      } else if (newPosition < this.dragMaxMonths) {
        newPosition = this.dragMaxMonths;
      }
      this.monthsArea.css('left', newPosition + 'px');
    },

    scrollDays: function (direction) {
      let currentLeft = this.daysArea.position().left;
      let newPosition = 0;
      let scrollWidth = (2 * this.dragAreaWidth / 3);
      if (direction === 'left') {
        newPosition = currentLeft - scrollWidth;
      } else {
        newPosition = currentLeft + scrollWidth;
      }
      if (newPosition > 0) {
        newPosition = 0;
      } else if (newPosition < this.dragMaxDays) {
        newPosition = this.dragMaxDays;
      }
      this.daysArea.css('left', newPosition + 'px');
    },

    appendEvents: function () {
      let event = null;
      for (event in this.eventsData.events) {
        let divElement = null;
        let eventDate = new Date(this.eventsData.events[event].date);
        let dateString = eventDate.getFullYear() + '-' + eventDate.getMonth() + '-' + eventDate.getDate();
        divElement = $(".timeline-day[date='" + dateString + "']");
        divElement.addClass('has-event');
      }
    },

    getDateString: function (eventDate) {
      let date = new Date(eventDate);
      let dateString = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate();
      return dateString;
    },

    addListeners: function () {
      document.body.addEventListener('mouseup', this.endDrag, false);
      document.body.addEventListener('mouseleave', this.endDrag, false);
      document.body.addEventListener('touchend', this.endDrag, false);

      let proxy = this;
      $('.timeline-month').click(function () {
        $('.month-selected').removeClass('month-selected');
        proxy.monthSelected = $(this).attr('month');
        $(this).addClass('month-selected');
        proxy.daySelected = null;
        proxy.scrollDayIntoView(proxy.monthSelected + '-1');
        proxy.filterEvents();
      });

      $('.timeline-day').click(function () {
        $('.day-selected').removeClass('day-selected');
        proxy.daySelected = $(this).attr('date');
        $(this).addClass('day-selected');
        proxy.highlightMonth(proxy.daySelected);
        proxy.monthSelected = null;
        proxy.filterByDay();
      });
    },

    removeListeners: function () {
      document.body.removeEventListener('mouseup', this.endDrag, false);
      document.body.removeEventListener('mouseleave', this.endDrag, false);
      document.body.removeEventListener('touchend', this.endDrag, false);
    },

    filterEvents: function () {
      let filteredEvents = this.eventsData.events;
      if (this.monthSelected) {
        let monthArray = this.monthSelected.split('-');
        let month = parseInt(monthArray[1]);
        let nextMonth = month + 1;
        let year = parseInt(monthArray[0]);
        let firstDay = new Date(year, month, 1);
        let lastDay = new Date(year, nextMonth, 0);
        let fromDateFiltered = [];
        for (let eventUuid in filteredEvents) {
          if (filteredEvents[eventUuid].hasOwnProperty('date')) {
            if (
              new Date(filteredEvents[eventUuid].date).getTime() >= firstDay.getTime() &&
              new Date(filteredEvents[eventUuid].date).getTime() < lastDay.getTime()
            ) {
              fromDateFiltered.push(filteredEvents[eventUuid]);
            }
          }
        }
        filteredEvents = fromDateFiltered;
      }
      this.filteredEvents = filteredEvents;
      $('.timeline-event-highlighted').removeClass('timeline-event-highlighted');
      if (this.daySelected) {
        this.highlightDay();
      }
    },

    filterByDay: function () {
      if (this.daySelected) {
        let dayArray = this.daySelected.split('-');
        this.monthSelected = parseInt(dayArray[0]) + '-' + parseInt(dayArray[1]);
        this.filterEvents();
      }
    }
  },

  created: function () {
    let proxy = this;
    this.promises.events.promise.then(function () {
      proxy.monthSelected = proxy.currentDate.getFullYear() + '-' + proxy.currentDate.getMonth();
      proxy.createCalendar();
      proxy.filterEvents();
      proxy.addListeners();
      proxy.isLoading = false;
    });
  },

  beforeDestroy: function () {
    this.removeListeners();
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/eventTimelineBlock/EventTimelineBlock.js